import { Zap, ShieldCheck, Network, Cpu, Gauge, Check, ArrowUpRight } from "lucide-react";
import { SERVICES, COMPANY } from "@/data";
import { Reveal } from "@/components/Reveal";

const ICONS = { Zap, ShieldCheck, Network, Cpu, Gauge };

export const Services = () => {
  return (
    <section id="uslugi" className="bg-white py-24 sm:py-32" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-3xl mb-16">
          <Reveal>
            <span className="text-xs font-semibold tracking-[0.2em] uppercase text-magenta">
              Zakres usług
            </span>
          </Reveal>
          <Reveal delay={80}>
            <h2 className="mt-4 font-heading font-bold text-navy text-3xl sm:text-4xl lg:text-5xl tracking-tight">
              Nasze usługi elektryczne i teletechniczne
            </h2>
          </Reveal>
          <Reveal delay={140}>
            <p className="mt-6 text-base sm:text-lg text-zinc-600 leading-relaxed">
              Od kompleksowych instalacji elektrycznych, przez systemy bezpieczeństwa i sieci
              słaboprądowe, po Smart Home i pomiary elektryczne z uprawnieniami SEP.
            </p>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {SERVICES.map((s, i) => {
            const Icon = ICONS[s.icon];
            return (
              <Reveal key={s.id} delay={(i % 3) * 100}>
                <article
                  id={s.id}
                  data-testid={`service-card-${s.id}`}
                  className="group h-full flex flex-col bg-white border border-zinc-200 hover:border-magenta hover:shadow-2xl transition-all duration-300"
                >
                  <div className="relative h-52 overflow-hidden">
                    <img
                      src={s.image}
                      alt={`${s.seo} – NDNS Elektro Katowice`}
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                    />
                    <div className="absolute inset-0 bg-navy-deep/30 group-hover:bg-navy-deep/10 transition-colors" />
                    <div className="absolute top-4 left-4 w-11 h-11 bg-magenta flex items-center justify-center text-white">
                      <Icon className="w-5 h-5" strokeWidth={2.2} />
                    </div>
                  </div>
                  <div className="p-7 flex flex-col flex-1">
                    <h3 className="font-heading font-bold text-xl text-navy leading-snug">
                      {s.title}
                    </h3>
                    <p className="mt-3 text-zinc-600 leading-relaxed text-sm">{s.desc}</p>
                    <ul className="mt-5 space-y-2">
                      {s.points.map((p) => (
                        <li key={p} className="flex items-start gap-2 text-sm text-navy font-medium">
                          <Check className="w-4 h-4 text-magenta mt-0.5 shrink-0" strokeWidth={2.5} />
                          {p}
                        </li>
                      ))}
                    </ul>
                    <a
                      href={COMPANY.phoneHref}
                      data-testid={`service-cta-${s.id}`}
                      className="mt-6 inline-flex items-center gap-1.5 text-sm font-bold text-magenta hover:gap-3 transition-all"
                    >
                      Zapytaj o wycenę <ArrowUpRight className="w-4 h-4" />
                    </a>
                  </div>
                </article>
              </Reveal>
            );
          })}

          <Reveal delay={200}>
            <div className="h-full min-h-[360px] bg-navy p-8 flex flex-col justify-between" data-testid="services-cta-card">
              <div>
                <Zap className="w-10 h-10 text-magenta-light" strokeWidth={2} />
                <h3 className="mt-6 font-heading font-bold text-2xl text-white leading-snug">
                  Masz projekt? Porozmawiajmy o Twojej instalacji.
                </h3>
                <p className="mt-3 text-zinc-300 text-sm leading-relaxed">
                  Bez względu na to, czy potrzebujesz podłączenia płyty indukcyjnej, czy pełnej
                  instalacji PPOŻ w hali – doradzimy najlepsze rozwiązanie.
                </p>
              </div>
              <a
                href={COMPANY.phoneHref}
                data-testid="services-cta-call"
                className="mt-8 inline-flex items-center justify-center gap-2 px-6 py-4 text-sm font-bold text-white bg-magenta hover:bg-magenta-light transition-colors"
              >
                Zadzwoń: {COMPANY.phone}
              </a>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
